import { render, staticRenderFns } from "./BaseImgTag.vue?vue&type=template&id=31fc7738&scoped=true"
import script from "./BaseImgTag.vue?vue&type=script&lang=js"
export * from "./BaseImgTag.vue?vue&type=script&lang=js"
import style0 from "./BaseImgTag.vue?vue&type=style&index=0&id=31fc7738&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc7738",
  null
  
)

export default component.exports